import { render, staticRenderFns } from "./EmptyIcon.vue?vue&type=template&id=04eee670&"
import script from "./EmptyIcon.vue?vue&type=script&lang=js&"
export * from "./EmptyIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports